"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
var react_calendar_1 = require("@zach.codes/react-calendar");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
require("../../../index.css");
var DefaultMonthlyEventItem = function (eventProps) {
    var _a, _b;
    var color = "";
    var hoverColor = "";
    switch (eventProps.status) {
        case "pending":
            color = "bg-purple-500";
            hoverColor = " hover:bg-purple-700 ";
            break;
        case "inProgress":
            color = "bg-orange-500";
            hoverColor = " hover:bg-orange-600 ";
            break;
        case "completed":
            color = "bg-green-500";
            hoverColor = " hover:bg-green-700 ";
            break;
        case "cancelled":
            color = "bg-red-600";
            hoverColor = " hover:bg-red-800 ";
            break;
        default:
            color =
                eventProps.customStatus && eventProps.status
                    ? eventProps.customStatus[(_a = eventProps.status) !== null && _a !== void 0 ? _a : ""].color
                    : "bg-indigo-500";
            hoverColor =
                eventProps.customStatus && eventProps.status
                    ? "hover:".concat(eventProps.customStatus[(_b = eventProps.status) !== null && _b !== void 0 ? _b : ""].hoverColor)
                    : "hover:bg-indigo-700";
            break;
    }
    return (react_1.default.createElement("li", { className: "rc-py-2 px-2" },
        react_1.default.createElement("div", { onClick: eventProps.onClick, className: "rc-flex rc-text-sm rc-flex-1 rc-justify-between ".concat(color, " rounded ").concat(hoverColor, " hover:cursor-pointer whitespace-normal break-words") },
            react_1.default.createElement("h3", { className: "text-white text-xs p-2 my-1" }, "".concat(eventProps.title, " - ").concat(eventProps.date)))));
};
function MonthlyDay(_a) {
    var renderDay = _a.renderDay;
    var locale = (0, react_calendar_1.useMonthlyCalendar)().locale;
    var _b = (0, react_calendar_1.useMonthlyBody)(), day = _b.day, events = _b.events;
    var dayNumber = (0, date_fns_1.format)(day, "d", { locale: locale });
    return (react_1.default.createElement("div", { "aria-label": "Events for day ".concat(dayNumber), className: "h-auto sm:h-32 md:h-36 p-2 border-b-2 border-r-2" },
        react_1.default.createElement("div", { className: "flex justify-between " },
            react_1.default.createElement("div", { className: "font-bold" }, dayNumber),
            react_1.default.createElement("div", { className: "lg:hidden block" }, (0, date_fns_1.format)(day, "EEEE", { locale: locale }))),
        react_1.default.createElement("ul", { className: " mt-2 overflow-hidden sm:max-h-20 lg:max-h-24 overflow-y-auto" }, renderDay(events))));
}
var MonthlyNav = function () {
    var _a = (0, react_calendar_1.useMonthlyCalendar)(), currentMonth = _a.currentMonth, onCurrentMonthChange = _a.onCurrentMonthChange;
    return (react_1.default.createElement("div", { className: "flex mb-4" },
        react_1.default.createElement("div", { className: "flex-grow" }),
        react_1.default.createElement("button", { onClick: function () { return onCurrentMonthChange((0, date_fns_1.subMonths)(currentMonth, 1)); }, className: "cursor-pointer font-bold text-primary-600 hover:text-primary-500" }, "Previous"),
        react_1.default.createElement("div", { className: "ml-4 mr-4 w-32 text-center" }, (0, date_fns_1.format)(currentMonth, "LLLL yyyy")),
        react_1.default.createElement("button", { onClick: function () { return onCurrentMonthChange((0, date_fns_1.addMonths)(currentMonth, 1)); }, className: "cursor-pointer font-bold text-primary-600 hover:text-primary-500" }, "Next")));
};
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Calendar.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(react_calendar_1.MonthlyCalendar, { currentMonth: this.props.currentDate, onCurrentMonthChange: this.props.handleMonthChange },
            react_1.default.createElement(MonthlyNav, null),
            react_1.default.createElement(react_calendar_1.MonthlyBody, { events: this.props.renderEventAvailabilities() },
                react_1.default.createElement(MonthlyDay, { renderDay: function (data) {
                        return data.map(function (item, index) { return (react_1.default.createElement(DefaultMonthlyEventItem, { key: index, title: item.title, status: item.status, customStatus: _this.props.customStatus, date: (0, date_fns_1.format)(item.date, "k:mm"), onClick: item.onClick })); });
                    } }))));
    };
    return Calendar;
}(react_1.Component));
exports.Calendar = Calendar;
//# sourceMappingURL=index.js.map